'use client';

import { t } from '@lingui/macro';
import EditIcon from '@mui/icons-material/Edit';
import StarIcon from '@mui/icons-material/Star';
import {
  Box,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import type { Theme } from '@mui/material/styles';
import { Application, useRouter } from '@prismo-io/router';
import type { LanguageCodeT } from '@prismo-io/schemas';
import { useParams } from 'next/navigation';
import { type FC, useCallback, useMemo } from 'react';
import { TypeQuarkEnum } from '../../../utils/type-quark-enum';

export type ItemListQuarkT = {
  id: string;
  name: string;
  favorite: number | null;
};

type Props = {
  index: string;
  item: ItemListQuarkT;
  type: TypeQuarkEnum;
  needBtn?: boolean;
  isFavorite?: boolean;
};

// const getModalPath = (type: TypeQuarkEnum) => {
//   switch (type) {
//     case TypeQuarkEnum.EXPERIENCE:
//       return '/profil/:user/competences-quark/experience/:id';
//     case TypeQuarkEnum.FORMATION:
//       return '/profil/:user/competences-quark/formation/:id';
//     case TypeQuarkEnum.SKILL:
//       return '/profil/:user/competences-quark/competence/:id';
//   }
// };

export const ItemListQuark: FC<Props> = (props) => {
  const { index, item, type, needBtn = true, isFavorite = false } = props;

  const router = useRouter();
  const params = useParams();

  const favoriteTooltip = useMemo(() => {
    switch (type) {
      case TypeQuarkEnum.EXPERIENCE:
        return t`Expérience principale | Affichée dans votre CV PRISMO`;
      case TypeQuarkEnum.FORMATION:
        return t`Formation principale | Affichée dans votre CV PRISMO`;
      case TypeQuarkEnum.SKILL:
        return t`Compétence principale | Affichée dans votre CV PRISMO`;
      case TypeQuarkEnum.DOMAIN:
        return t`Compétence principale | Affichée dans votre CV PRISMO`;
    }
  }, [type]);

  const getRouterPushToModal = (type: TypeQuarkEnum) => {
    switch (type) {
      case TypeQuarkEnum.EXPERIENCE:
        router.push({
          app: Application.APP,
          path: '/profil/:user/competences-quark/experience/:id',
          params: {
            user: params.user as string,
            id: item.id,
          },
          locale: params.locale as LanguageCodeT,
        });
        break;
      case TypeQuarkEnum.FORMATION:
        router.push({
          app: Application.APP,
          path: '/profil/:user/competences-quark/formation/:id',
          params: {
            user: params.user as string,
            id: item.id,
          },
          locale: params.locale as LanguageCodeT,
        });
        break;
      case TypeQuarkEnum.SKILL:
        router.push({
          app: Application.APP,
          path: '/profil/:user/competences-quark/competence/:id',
          params: {
            user: params.user as string,
            id: item.id,
          },
          locale: params.locale as LanguageCodeT,
        });
        break;
    }
  };

  const onEdit = useCallback(() => {
    getRouterPushToModal(type);

    // router.push({
    //   app: Application.APP,
    //   path: path,
    //   params: {
    //     user: params.user as string,
    //     id: item.id,
    //   },
    //   locale: params.locale as LanguageCodeT,
    // });
  }, [params.locale, params.user, item.id, type]);

  return (
    <Grid
      item
      md={6}
      width="100%"
      sx={{
        maxWidth: {
          md: 'calc(50% - 1rem)',
          lg: 'calc(50% - 1rem)',
          xl: 'calc(50% - 1rem)',
        },
      }}
    >
      <Box
        component="div"
        border="1px solid"
        borderColor={(theme: Theme) => theme.palette.primary.main}
        paddingX={2}
        paddingY={1}
        bgcolor="white"
      >
        <Stack
          width="100%"
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography fontWeight="bolder">
            {index} | {item.name}
          </Typography>
          <Stack direction="row" gap={1} alignItems="center">
            {isFavorite && (
              <Tooltip title={favoriteTooltip} placement="bottom">
                <StarIcon fontSize="small" sx={{ color: 'gold' }} />
              </Tooltip>
            )}
            {needBtn && (
              <IconButton size="small" onClick={onEdit}>
                <EditIcon fontSize="small" />
              </IconButton>
            )}
          </Stack>
        </Stack>
      </Box>
    </Grid>
  );
};
